import { useEffect, useState } from 'react';
import { isApplePaySdkLoaded } from '../utils/applePayUtils';

export const useApplePayAvailable = () => {
  const [available, setAvailable] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  /**
   * Check if Apple Pay is available
   * Returns true if either:
   * - Native ApplePaySession is available and can make payments (Safari)
   * - SDK is loaded (enables QR code flow for non-Safari browsers)
   */
  useEffect(() => {
    const supportedByDevice = 'ApplePaySession' in window && ApplePaySession !== undefined;
    const merchantId = import.meta.env.VITE_APPLE_PAY_MERCHANT_ID ?? '';
    const sdkLoaded = isApplePaySdkLoaded();
    
    if (supportedByDevice) {
      ApplePaySession?.canMakePaymentsWithActiveCard(merchantId)
        .then((canMakePayments) => {
          console.log('Apple Pay - Can make payments:', canMakePayments);
          // Available if native payment works OR SDK is loaded (for QR code flow)
          if (canMakePayments || sdkLoaded) {
            setAvailable(true);
          }
          setIsLoading(false);
        })
        .catch((e) => {
          console.log('Error when checking if Apple Pay is available: ', e);
          // If native check fails but SDK is loaded, still enable QR code flow
          if (sdkLoaded) {
            setAvailable(true);
          }
          setIsLoading(false);
        });
    } else {
      // No native support, but SDK might enable QR code flow
      if (sdkLoaded) {
        setAvailable(true);
      }
      setIsLoading(false);
    }
  }, []);

  return { applePayAvailable: available, applePayAvailableLoading: isLoading };
};
